import { OrganizationInvitationStatuses } from "../../../generated/OrganizationInvitations";
import { EmploymentStatusResponse } from "../EmploymentStatusResponse";
import { NameEntityResponse } from "../NameEntityResponse";
import { RoleResponse } from "../RoleResponse";

export interface OrganizationDetailsResponse {
  id: number;
  name: string;
  status: OrganizationStatusResponse;
  contact: NameEntityResponse;
  email: string;
  phone: string;
  description: string;
  vat: string;
  countryCode: string;
  address: string;
  addressNumber: string;
  zip: string;
  city: string;
  state: string;
  hasPaidSubscription: boolean;
  created: Date;
  createdBy: NameEntityResponse;
  modified?: Date | null;
  modifiedBy?: NameEntityResponse;
  isDemo: boolean;
  allowEnterprise: boolean;
  hasStripeCustomer: boolean;
  generalManagerFirstName: string;
  generalManagerLastName: string;
  websiteURL?: string;
}

export const emptyOrganization: OrganizationDetailsResponse = {
  id: 0,
  name: "",
  contact: {
    id: 0,
    name: "",
    isDeleted: false,
  },
  description: "",
  created: new Date(),
  createdBy: {
    id: 0,
    name: "",
    isDeleted: false,
  },
  vat: "",
  countryCode: "",
  state: "",
  city: "",
  zip: "0",
  address: "",
  addressNumber: "",
  hasPaidSubscription: false,
  status: {
    id: 0,
    name: "",
    translationKey: "",
  },
  email: "",
  phone: "",
  isDemo: false,
  allowEnterprise: false,
  hasStripeCustomer: false,
  generalManagerFirstName: "",
  generalManagerLastName: "",
};

export interface UserOrganizationInvitationResponse {
  id: number;
  organizationInvitationStatus: OrganizationInvitationStatuses;
  created: Date;
  organizationDetails: OrganizationDetailsResponse;
  role: RoleResponse;
  employmentStatus: EmploymentStatusResponse;
}

export interface OrganizationStatusResponse {
  id: number;
  name: string;
  translationKey: string;
}
